export const enums = {
	DOMAINS: ['POS', 'App', 'The List'],
	TYPES: [
		'Product Abbreviation', // L
		'Product Variant Abbreviation', // L
		'Ingredient Abbreviation', // L
		'Product Tile', // !L
		'Product Details', // A
		'Product Ingredients Left', // A
		'Product Ingredients Right', // a
		'Ingredient Tile', // a
		'Menu Logo', // a
		'Allergy', // a
	],
	POS_TYPES: ['Product Tile'],
	APP_TYPES: [
		'Product Tile',
		'Product Details', // A
		'Product Ingredients Left', // A
		'Product Ingredients Right', // a
		'Ingredient Tile', // a
		'Menu Logo', // a
		'Allergy', // a
		'Row Layout Tile',
		'Row Layout Product Detail',
		'Product Recommendation',
	],
	LIST_TYPES: [
		'Product Abbreviation', // L
		'Product Variant Abbreviation', // L
		'Ingredient Abbreviation', // L
	],
};
